import { render, staticRenderFns } from "./RetailerBrandProduct.vue?vue&type=template&id=2672b336"
import script from "./RetailerBrandProduct.vue?vue&type=script&lang=js"
export * from "./RetailerBrandProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports